import{useContext as e}from"react";import n from"../components/ConnectContext.js";const o=()=>{const{providerAndSigner:r}=e(n);return r||{provider:null,signer:null}};var m=o;export{m as default};
